import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'pcs-modal-header',
  template: '<ng-content></ng-content>'
})
export class ModalHeaderComponent {

  @HostBinding('class.d-flex')
  @HostBinding('class.w-100')
  private rootClasses = true;

}
